import { StringMappingType } from 'typescript';
import axiosInstance from './Axios';
import { itemGroup } from 'shared/constants/ItemConstant';
interface PaymentHistoryDataType{
  key:number;
  id: number;
  amount: number;
  date: string;
  method : string;
  handler : string;
  paymentNote: string;
}

export interface CalculateItem {
  id?: string;
  width?: string;
  height?: string;
  // vertical blinds
  fitting?: string;
  blind_type_id?: number;
  blind_sub_type_id?: number;
  //  roller blinds
  operation?: string;
  roller_size?: string;
  type?: number;
  //  roller shutter
  height_l?: string;
  height_r?: string;
  shutter_type?: string;
  bottom_angle?: string;
  bot_guide?: string;
  discount_type?: string;
}
export interface CalculateResult {
  id: string;
  price: string;
  itemCost: string;
  inPrice: string;
  outPrice: string;
  // vertical blinds
  track_cut: string;
  blade_cut: string;
  no_blade: string;
  no_bracket: string;
  //  roller blinds
  roller_size : string;
  tube_type : string;
  top_roller: string;
  bottom_bar: string;
  fabric_width: string;
  fabric_drop: string;
  total_fabric_width: string;
  //  roller shutter
  pelmet_size: string;
  pelmet_cut: string;
  slat_cut: string;
  no_slat: string;
  bot: string;
  oct: string;
  'guide-L': string;
  'guide-R': string;
  motor_nm: string;
  // protecta
  hood_cut: string;
  tube_cut: string;
  bottom_rail: string;
  channel_left: string;
  channel_right: string;
  tention_track_left: string;
  tention_track_right: string;
  fabric_width_only_skin: string;
  fabric_width_inc_zip: string;
  arm_extrusion: string;
  sliding_rail: string;
  wire_length: string;
  axels: string;
  // awning
  bottom_bar_pocket: string;
  total_height: string;
  bottom_bar_width: string;
  hems: string;
  fabric_used: string;
  motor_size: string;
  hood_width: string;
  tube_size: string;
  // shop front awning
  extra_height: string;
  pocket_height: string;
  awning_height: string;
  bot_bar_pocket: string;
  total_fabic_height: string;
  top_timber_width: string;
  total_width: string;
  cord_length: string;
  // SRS awning
  outer_channel_left: string;
  outer_channel_right: string;
  inner_channel_left: string;
  inner_channel_right: string;

  // venetian
  real_width: string;
  real_height: string;

}

export function calculate(items: Array<CalculateItem | undefined>) {
  return axiosInstance
    .post<CalculateResult[]>('/calculate', { items })
    .then((response) => response.data);
}

export function cost_estimation(items: Array<CalculateItem | undefined>) {
  return axiosInstance
    .post<CalculateResult[]>('/cost-estimation', { items })
    .then((response) => response.data);
}
// Get List Ship To



export interface CreateOrderItem {
  product_id: string;
  location?: string;
  note?:string;
  width?: string;
  height?: string;
  fitting?: string;
  control_side?: string;
  stack_direction?: string;
  track_cut?: string; 
  control_stack?: string;
  control_material?: string;
  blade_cut?: string;
  no_of_blade?: string;
  price?: string;
  // roller blind
  roll_style?: string;
  roller_size_id?: string;
  roller_size?: string;
  control_length?: string;
  operation_id?: string;
  operation?: string;
  top_roller?: string;
  bottom_bar?: string;
  fabric_width?: string;
  fabric_drop?: string;
  //  roller shutter
  height_l?: string;
  height_r?: string;
  bottom_angle?: string;
  pelmet_size?: string;
  pelmet_cut?: string;
  slat_cut?: string;
  no_slat?: string;
  bot?: string;
  oct?: string;
  'guide-L'?: string;
  'guide-R'?: string;
  motor_nm?: string;
  angle_top?: string;
  angle_bot?: string;
  angle_left?: string;
  angle_right?: string;
  bot_guide?: string;
  //  protecta
  hood_cut?: string;
  tube_cut?: string;
  bottom_rail?: string;
  channel_left?: string;
  channel_right?: string;
  tention_track_left?: string;
  tention_track_right?: string;
  fabric_width_only_skin?: string;
  fabric_width_inc_zip?: string;
  arm_extrusion?: string;
  sliding_rail?: string;
  wire_length?: string;
  main_info: {
    blind_type?: string;
    blind_type_name?: string;
    fabric_type?: string;
    fabric_type_name?: string;
    fabric_detail?: string;
    track_color?: string;
    track_color_name?: string;
    control_style?: string;
    link?: string;
    // roller blind
    fabric_type_id?: string;
    bottom_bar_id?: string;
    bottom_bar?: string;
    bottom_bar_other?: string;
    fabric_rotation?: string;
    // roller cassette
    cassette_colour_id?: string;
    cassette_colour?: string;
    other_colour?: string;
    // roller shutter
    hood_color?: string;
    hood_color_name?: string;
    powder_color?: string;
    guide_color?: string;
    guide_color_name?: string;
    bottom_bar_color?: string;
    bottom_bar_color_name?: string;
    slat_primary_color?: string;
    slat_primary_color_name?: string;
    slat_secondary_color?: string;
    slat_secondary_color_name?: string;
    shutter_type?: string;
    shutter_type_name?: string;
    guide_type?: string;
    guide_type_name?: string;
    pattern?: string;
    // protecta
    fabric_catalog?: string;
    fabric_catalog_id?: string;
    fabric_name?: string;
    hood_color_id?: string;
    channel_color?: string;
    channel_color_id?: string;
    hood_size?: string;
    hood_size_id?: string;
    top_roller_size?: string;
    top_roller_size_id?: string;
    // EZE awning
    hood_type_name?: string;
    hood_type?: string;
  };
  is_fitted: boolean;
  extra_price?: number;
  extra_info?: ExtraInfor[];
}

export interface GoogleLocation {
  lng?: string;
  lat?: string;
}
export interface CreateOrderRequest {
  customer_info: {
    id?: string;
    name: string;
    contact: string;
    address: string;
    type: string;
    company: string;
    email: string;
    bill_coordinate: GoogleLocation;
  };
  save_customer:boolean;
  shipTo: string;
  coordinate: GoogleLocation;
  customer_reference: string;
  fitter:string;
  order_note:string;
  payment:PaymentHistoryDataType[];
  order_type: string;
  discount_type: string;
  time_spent: string;
  extra_cost: string;
  price: string;
  total_price: string;
  order_gst: string;
  order_date: string;
  discount: string;
  fitting_date: string;
  fitting_time: string;
  fitting_time_end:string;
  items: Array<CreateOrderItem | undefined>;
  comment: Comment[]
}

interface CreateOrderResponse {
  order_id:string
}
export function createOrder(data: CreateOrderRequest) {
  return axiosInstance
    .post<CreateOrderResponse>('/orders', data)
    .then((response) => response.data);
}

export interface OrderSummary {
  name:string;
  product_id:number;
  quantity:number;
}

export interface Order {
  id: string;
  order_code: string;
  order_refer_no: string;
  email: string;
  shipTo: string;
  coordinate: GoogleLocation;
  billCoordinate: GoogleLocation;
  created_date: string;
  fitting_before: string;
  fitting_date: string;
  fitting_time:string;
  fitting_time_end:string;
  fitter:string;
  order_note:string;
  price: string;
  status: string;
  balance: string;
  deposit: string;
  name:string;
  contact:string;
  discount_type: string;
  order_type:string;
  summary:OrderSummary[];
  comment: Comment[];
  first_name: string;
  last_name: string;
  user_id: string;
}

export interface OrderListParams {
  page?: number;
  page_size?: number;
  name?: string;
  contact?: string;
  order_refer_no?: string;
  fitter?: string;
  status?: string[];
  order_date_from?: string;
  order_date_to?: string;
  fitting_date_from?: string;
  fitting_date_to?: string;
  product_ids?: number[];
  sort?: number[];
}

export interface PaginatedOrders {
  data: Order[];
  total: number;
  page: number;
  page_size: number;
}

export function getListOrder(params: OrderListParams = {}) {
  // Serialize array params as comma-separated strings and drop empty values
  const query: Record<string, string | number> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (Array.isArray(value)) {
      if (value.length === 0) return;
      query[key] = value.join(',');
    } else {
      query[key] = value as string | number;
    }
  });
  return axiosInstance
    .get<PaginatedOrders>('/orders', { params: query })
    .then((response) => response.data);
}




export function getUserOrderHistory(user_id:string) {
  const params = { user_id };
  return axiosInstance
    .get<Order[]>('/user-order-history', { params })
    .then((response) => response.data);
}

export function getUserOrderHistorySummary(user_id:string) {
  const params = { user_id };
  return axiosInstance
    .get('/user-order-history-summary', { params })
    .then((response) => response.data);
}

export interface Customer {
  id: number;
  name: string;
  address: string;
  type: string;
  company: string;
  contact: string;
  email: string;
  shipTo: string;
  coordinate: GoogleLocation;
  bill_coordinate: GoogleLocation;
}

export function getListCustomers() {
  return axiosInstance
    .get<Customer[]>('/customers')
    .then((response) => response.data);
}

// Order Detail
export interface OrderDetailItem {
  tube_size: string;
  id: number;
  is_fitted: boolean;
  blade_cut: string;
  no_bracket:string;
  control_side: string;
  fitting: string;
  fitting_to: string;
  height: string;
  location: string;
  note?: string;
  control_stack: string;
  control_material: string;
  no_of_blade: string;
  price: string;
  product_id: string;
  stack_direction: string;
  track_cut: string;
  width: string;
  
  // roller
  fabric_name: string;
  bottom_bar: string;
  control_length: string;
  fabric_drop: string;
  fabric_width: string;
  total_fabric_width:string;
  operation: string;
  operation_id: number;
  roll_style: string;
  item_list: itemGroup[];
  roller_size: string;
  roller_size_id: number;
  top_roller: string;
  tube_type: string;
  pelmet: string;
  // roller shutter
  height_l: string;
  height_r: string;
  bot_guide: string;
  bottom_angle: string;
  pelmet_size: string;
  pelmet_cut: string;
  slat_cut: string;
  no_slat: string;
  bot: string;
  oct: string;
  'guide-L': string;
  'guide-R': string;
  axels: string;
  motor_nm: string;
  // protecta
  hood_cut: string;
  tube_cut: string;
  bottom_rail: string;
  channel_left: string;
  channel_right: string;
  tention_track_left: string;
  tention_track_right: string;
  arm_extrusion: string;
  sliding_Rail: string;
  wire_length: string;
  fabric_width_only_skin: string;
  fabric_width_inc_zip: string;
  //  awning
  valance: string;
  bcaa: number;
  bcaa_name: string;
  bottom_bar_pocket: string;
  total_height: string;
  bottom_bar_width: string;
  hems: string;
  fabric_used: string;
  motor_size: string;
  hood_width: string;
  // shop front awning
  jhook_height: string;
  extra_height: string;
  pocket_height: string;
  awning_height: string;
  bot_bar_pocket: string;
  total_fabic_height: string;
  top_timber_width: string;
  total_width: string;
  cord_length: string;
  control_looking: string;
  // SRS awning
  outer_channel_left: string;
  outer_channel_right: string;
  inner_channel_left: string;
  inner_channel_right: string;

  //Z Blinds
  cassette_type:string;
  bottom_wrap:string;

  //CURTAIN
  stack: string;
  left_return: number;
  right_return: number;
  make: number;
  tie_back: string;
  fabric_style: string;
  bracket_type: string;
  track_type: string;
  //CURVER
  extra_slat: number;
  extra_bracket: number;
  bottom_support: string;

  // VENETIAN
  material: string;
  slat_size: string;
  slat_width: number;
  real_width: string;
  real_height: string;
  /// PLANTATIOM
  layout: string;
  custom_layout: string;
  top: boolean,
  right: boolean,
  left: boolean,
  bottom: boolean,
  no_panel: number,
  mid_rail: number,
  mount: string,
  t_post:number,
  cut_tilt: number,
  T_post_setting: string,
  plantation_color:string,
  // FOLDING ARM
  folding_type: string;
  pelmet_width: number;
  // AA PLANTATION
  track: string;
  handle: string;
  // T PLANTATION

  // GLIDE
  fix_type: string;
  control_rod: string;
  fabric_rotation:string
  // PART
  quantity: number;

  //ROMAN
  control_style : string;

  cost : number;

  //ROLLER BLIND GROUP

  
  main_info: {
    operation: string;
    operation_id: number;
    description: string;
    roman_track_name: string;
    roman_track_id: number;
    glide_color:string;
    glide_color_id: number;
    hinge_color_name: string;
    hinge_color: number;
    mount_method_name: string;
    mount_method: number;
    rafter_bracket: string;
    rafter_bracket_id: number;
    weather_color_name: string,
    weather_color: number,
    folding_color_name: string,
    folding_color: number,
    frame_code_name: string,
    frame_code: number,
    plan_blade_size_name : string,
    plan_blade_size: number,
    plan_material_name: string,
    plantation_color:string;
    plan_material: number;
    plan_color_name: string;
    plan_color: number;
    valance_hook: string;
    valance_hook_id: number;
    slat_color_name: string;
    slat_color: number;
    crank_color_name: string;
    crank_color: number;
    curver_pattern_name: string;
    curver_pattern: number;
    curver_color_name: string;
    curver_color: number;
    wand_color:number;
    wand_color_name: string;
    bracket_color_name: string;
    track_brand: number;
    track_brand_name: string;
    roller_style: string;
    control_length: number;
    blind_type: number;
    blind_type_name: string;
    control_style: string;
    fabric_detail: string;
    fabric_detail2: string;
    fabric_type: number;
    fabric_type_name: string;
    fabric_type2_name: string;
    fabric_col_name: string;
    curtain_heading_name: string;
    curtain_heading: number;
    lining_option_name: string;
    lining_option:number;
    fabric_col: number;
    link: string;
    track_color: number;
    track_color_name: string;
    control_color: number;
    control_color_name: string;
    cassette_color_name: string;
    cassette_color: number;
    
    // roler
    bottom_bar: string;
    bottom_bar_id: number;
    bottom_bar_type: string;
    bottom_bar_type_id: number;
    bottom_bar_other: string;
    fabric_rotation: string;
    fabric_type_id: number;
    fabric_type2_id: number;
    part_type_id: number;
    part_type_name: string;
    part_color:string;
    bracket: string;
    bracket_id: number;
    bracket_color: string;
    bracket_color_id: number;
    // roller cassette
    cassette_colour: string;
    cassette_colour_id: number;
    //  roller shutter
    pelmet_color: number;
    pelmet_color_name: string;
    guide_color: number;
    guide_color_name: string;
    bottom_bar_color: number;
    bottom_bar_color_name: string;
    slat_primary_color: number;
    slat_primary_color_name: string;
    slat_secondary_color: number;
    slat_secondary_color_name: string;
    shutter_type: number;
    shutter_type_name: string;
    guide_type: number;
    guide_type_name: string;
    pattern: string;
    bottom_type: number;
    bottom_type_name: string;
    // protecta
    fabric_catalog_name: string;
    fabric_catalog: number;
    fabric_name: string;
    rubber_seal: string;
    hood_color_name: string;
    hood_color: number;
    powder_color:string;
    channel_color_name: string;
    channel_color: number;
    hood_size_name: string;
    hood_size: number;
    tube_size_name: string;
    tube_size: number;
    // awning - shop front awning
    valance_style: number;
    valance_style_name: string;
    hood: string;
    // EZE awning
    hood_type: number;
    hood_type_name: string;
  };
  extra_price: string;
  extra_info: ExtraInfor[];
}

export interface OrderDetailResponse {
  order_detail: {
    order_id: number;
    order_code: string;
    order_type: string;
    discount_type: string;
    customer_reference: string;
    fitter:string;
    order_note:string;
    payment: PaymentHistoryDataType[];
    order_refer_no: string;
    ship_to_id: number;
    status: string;
    total_cost: number;
    created_by: number;
    created_date: string;
    install_date: string;
    fitting_before: string;
    fitting_date: string;
    fitting_time:string;
    fitting_time_end:string;
    discount: number;
    time_spent: number;
    price: number;
    total_price: number;
    order_gst:number;
    deposit: number;
    balance: number;
    shipTo: string;
    coordinate: GoogleLocation;
    comment: Comment[];
   
    customer_info: {
      id: number;
      address: string;
      contact: string;
      email: string;
      type: string;
      company: string;
      name: string;
      bill_coordinate: GoogleLocation;
    };
    summary: OrderSummary[];
  };
  items: OrderDetailItem[];
  
}
export interface Comment {
  key:number;
  message:string;
  madeBy: string;
  commentDate:string;
  color:string;
}

export function getOrderDetailById(id: string) {
  const params = { id };
  return axiosInstance
    .get<OrderDetailResponse>(`orders`, { params })
    .then((response) => response.data);
}

// Edit Order
export interface ExtraInfor {
  id: number;
  price: number;
  requirement: string;
  length: number;
  unit_price: number;
  price_index: number;
}

export interface EditOrderItem {
  product_id: string;
  location?: string;
  note?: string;
  width?: string;
  height?: string;
  fitting?: string;
  control_side?: string;
  stack_direction?: string;
  track_cut?: string;
  blade_cut?: string;
  no_of_blade?: string;
  price?: string;
  delete_flag?: boolean;
  // roller blind
  roll_style?: string;
  roller_size_id?: string;
  roller_size?: string;
  control_length?: string;
  operation_id?: string;
  operation?: string;
  top_roller?: string;
  bottom_bar?: string;
  fabric_width?: string;
  fabric_drop?: string;
  //  roller shutter
  height_l?: string;
  height_r?: string;
  bottom_angle?: string;
  pelmet_size?: string;
  pelmet_cut?: string;
  slat_cut?: string;
  no_slat?: string;
  bot?: string;
  oct?: string;
  'guide-L'?: string;
  'guide-R'?: string;
  motor_nm?: string;
  angle_top?: string;
  angle_bot?: string;
  angle_left?: string;
  angle_right?: string;
  //  protecta
  hood_cut?: string;
  tube_cut?: string;
  bottom_rail?: string;
  channel_left?: string;
  channel_right?: string;
  tention_track_left?: string;
  tention_track_right?: string;
  fabric_width_only_skin?: string;
  fabric_width_inc_zip?: string;
  arm_extrusion?: string;
  sliding_rail?: string;
  wire_length?: string;
  main_info: {
    blind_type?: string;
    blind_type_name?: string;
    fabric_type?: string;
    fabric_type_name?: string;
    fabric_detail?: string;
    track_color?: string;
    track_color_name?: string;
    control_style?: string;
    link?: string;
    // roller blind
    fabric_type_id?: string;
    bottom_bar_id?: string;
    bottom_bar?: string;
    bottom_bar_other?: string;
    fabric_rotation?: string;
    // roller cassette
    cassette_colour_id?: string;
    cassette_colour?: string;
    other_colour?: string;
    // roller shutter
    pelmet_color?: string;
    pelmet_color_name?: string;
    guide_color?: string;
    guide_color_name?: string;
    bottom_bar_color?: string;
    bottom_bar_color_name?: string;
    slat_primary_color?: string;
    slat_primary_color_name?: string;
    slat_secondary_color?: string;
    slat_secondary_color_name?: string;
    shutter_type?: string;
    shutter_type_name?: string;
    guide_type?: string;
    guide_type_name?: string;
    pattern?: string;
    // protecta
    fabric_catalog?: string;
    fabric_catalog_id?: string;
    fabric_name?: string;
    hood_color_id?: string;
    channel_color?: string;
    channel_color_id?: string;
    hood_size?: string;
    hood_size_id?: string;
    top_roller_size?: string;
    top_roller_size_id?: string;
    // EZE awning
    hood_type_name?: string;
    hood_type?: string;
  };
  is_fitted: boolean;
  extra_price?: number;
  extra_info?: ExtraInfor[];
}

export interface EditOrderDetail {
  customer_info: {
    id: string;
    name: string;
    address: string;
    contact: string;
    type: string;
    company: string;
    email: string;
    bill_coordinate: GoogleLocation;
  };
  shipTo:string;
  coordinate: GoogleLocation;
  save_customer:boolean;
  order_code: string;
  order_type: string;
  discount_type: string;
  customer_reference: string;
  fitter:string;
  order_note:string;
  payment:PaymentHistoryDataType[];
  order_date: string;
  discount: string;
  time_spent: string;
  total_price: string;
  order_gst:string;
  price: string;
  extra_cost: string;
  fitting_date: string;
  fitting_time:string;
  fitting_time_end:string;
  balance?: number;
  deposit?: number;
  items: Array<EditOrderItem | undefined>;
  comment:Comment[];
}

export interface EditOrderPayment {
  payment:PaymentHistoryDataType[];
  deposit?: number;
}


export interface InstallationData {
  fitting_date: string;
  fitting_time: string;
  fitting_time_end: string;
  fitter:string;
  shipTo: string;
  coordinate: GoogleLocation;
}

export interface EditCustomerData {
  id?: string;
  customerName: string;
  email: string;
  address: string;
  bill_coordinate: GoogleLocation;
  company: string;
  type: string;
  phone: string;
  save_customer:boolean;
}


export function editOrderDetailById(
  id: string,
  editOrderDetail: EditOrderDetail,
) {
  const params = { id };
  return axiosInstance
    .put<OrderDetailResponse>(`orders`, editOrderDetail, { params })
    .then((response) => response.data);
}

export function editOrderPaymentById(
  id: string,
  editOrderPayment: EditOrderPayment,
) {
  const params = { id };
  return axiosInstance
    .put<OrderDetailResponse>(`order-payment`, editOrderPayment, { params })
    .then((response) => response.data);
}

export function editOrderFittingById(
  id: string,
  editOrderPayment: InstallationData,
) {
  const params = { id };
  return axiosInstance
    .put<OrderDetailResponse>(`order-fitting`, editOrderPayment, { params })
    .then((response) => response.data);
}

export function editOrderCustomerById(
  id: string,
  editOrderPayment: EditCustomerData,
) {
  const params = { id };
  return axiosInstance
    .put<OrderDetailResponse>(`order-customer`, editOrderPayment, { params })
    .then((response) => response.data);
}

interface commentData {
  comment:Comment[]
}
export function editOrderCommentById(
  id: string,
  editOrderPayment: commentData,
) {
  const params = { id };
  return axiosInstance
    .put<OrderDetailResponse>(`order-comment`, editOrderPayment, { params })
    .then((response) => response.data);
}

// Delete Order
export function deleteOrderById(id: string) {
  const params = { id };
  return axiosInstance
    .delete(`orders`, { params })
    .then((response) => response.data);
}

// Change Order Status
export function changeOrderStatusById(order_id: string, status: string) {
  return axiosInstance
    .post(`order-status`, { order_id, status })
    .then((response) => response.data);
}

// Print Quotation
export function printQuotation(order_id: string) {
  const params = { order_id };
  return axiosInstance
    .get(`/print-quotation`, { params })
    .then((response) => response.data);
}

// Print Instruciton
export function printInstruciton(order_id: string) {
  const params = { order_id };
  return axiosInstance
    .get(`/print-instruction`, { params })
    .then((response) => response.data);
}

export function printInstrucitonSupplier(order_id: string) {
  const params = { order_id };
  return axiosInstance
    .get(`/print-instruction-supplier`, { params })
    .then((response) => response.data);
}

// Print Instruciton No Optimisation
export function printInstrucitonNoOptimisation(order_id: string) {
  const params = { order_id };
  return axiosInstance
    .get(`/print-instruction-no-optimisation`, { params })
    .then((response) => response.data);
}

// Print Invoice
export function printInvoice(order_id: string) {
  const params = { order_id };
  return axiosInstance
    .get(`/print-invoice`, { params })
    .then((response) => response.data);
}

export function printTaxInvoice(order_id: string) {
  const params = { order_id };
  return axiosInstance
    .get(`/print-tax-invoice`, { params })
    .then((response) => response.data);
}

// Send Quotation
export function sendQuotation(order_id: string) {
  const params = { order_id };
  return axiosInstance
    .get(`/send-quotation`, { params })
    .then((response) => response.data);
}
export function smsInvoice(order_id: string) {
  const params = { order_id };
  return axiosInstance
    .get(`/sms-invoice`, { params })
    .then((response) => response.data);
}
export function smsTaxInvoice(order_id: string) {
  const params = { order_id };
  return axiosInstance
    .get(`/sms-tax-invoice`, { params })
    .then((response) => response.data);
}
export function smsPaymentReminder(order_id: string) {
  const params = { order_id };
  return axiosInstance
    .get(`/sms-payment-reminder`, { params })
    .then((response) => response.data);
}
// sms Quotation
export function smsQuotation(order_id: string) {
  const params = { order_id };
  return axiosInstance
    .get(`/sms-quotation`, { params })
    .then((response) => response.data);
}

// Send Quotation
export function sendInvoice(order_id: string) {
  const params = { order_id };
  return axiosInstance
    .get(`/send-invoice`, { params })
    .then((response) => response.data);
}

export function sendTaxInvoice(order_id: string) {
  const params = { order_id };
  return axiosInstance
    .get(`/send-tax-invoice`, { params })
    .then((response) => response.data);
}

// Move Order Items
export interface MoveItemResponse {
  message: string;
  order_id: number;
}
export function moveOrderItem(order_id: string, items_id: string[]) {
  const params = { order_id };
  const itemsId = { items_id };
  return axiosInstance
    .post<MoveItemResponse>(`/move-item`, itemsId, { params })
    .then((response) => response.data);
}

// Print Invoice
export function orderDuplicate(order_id: string) {
  const params = { order_id };
  return axiosInstance
    .get(`/duplicate-order`, { params })
    .then((response) => response.data);
}
